export default __webpack_public_path__ + "static/media/storm-2.830cafb2.png";